import sidebar from '@/config/sidebars/adminHubspot'
import createVueApp from '@/common/createApp'

Styxie.Initializers.AdminHubspotContacts = {
  index: async(props) => {
    const { default: ContactsIndex } = await import('@/vue_widgets/admin/hubspot/contacts/index.vue')
    createVueApp(ContactsIndex, { props, sidebar })
  },
  show: async(props) => {
    const { default: ContactsShow } = await import('@/vue_widgets/admin/hubspot/contacts/show.vue')
    createVueApp(ContactsShow, { props, sidebar })
  }
}
